module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Aaf"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Other Books by H. Jackson Brown, Jr."
    }
  }, [_c('h1', {
    staticClass: "ct_1",
    attrs: {
      "id": "pz4-1"
    }
  }, [_vm._v("Other Books by H. Jackson Brown, Jr. ")]), _vm._v(" "), _c('p', {
    staticClass: "noind1"
  }, [_c('em', [_vm._v("A Father’s Book of Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-3"
    }
  }, [_c('em', [_vm._v("P.S. I Love You")])]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-4"
    }
  }, [_c('em', [_vm._v("Life’s Little Instruction Book™")]), _vm._v(" "), _c('br'), _vm._v(" (volumes I, II, and III)")]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-6"
    }
  }, [_c('em', [_vm._v("Live and Learn and Pass It On")]), _vm._v(" "), _c('br'), _vm._v(" (volumes I, II, and III)")]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-8"
    }
  }, [_c('em', [_vm._v("Wit and Wisdom from the Peanut Butter Gang")])]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-9"
    }
  }, [_c('em', [_vm._v("The Little Book of Christmas Joys")]), _vm._v(" "), _c('br'), _vm._v(" (with Rosemary C. Brown and Kathy Peel)")]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-11"
    }
  }, [_c('em', [_vm._v("A Hero in Every Heart")]), _vm._v(" "), _c('br'), _vm._v(" (with Robyn Spizman)")]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-13"
    }
  }, [_c('em', [_vm._v("Life’s Little Treasure Books")]), _vm._v(" "), _c('br'), _vm._v(" On Marriage and Family, On Wisdom, On Joy, On Success, On Love, On Parenting,"), _c('br'), _vm._v(" Of Christmas Memories, Of Christmas Traditions, On Hope, On Friendship,"), _c('br'), _vm._v(" On Fathers, On Mothers, On Things That Really Matter, On Simple Pleasures")]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-17"
    }
  }, [_c('em', [_vm._v("Kids’ Little Treasure Books")]), _vm._v(" "), _c('br'), _vm._v(" On Happy Families, On What We’ve Learned . . . So Far")]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-19"
    }
  }, [_c('em', [_vm._v("Life’s Little Instructions from the Bible")]), _vm._v(" "), _c('br'), _vm._v(" (with Rosemary C. Brown)")]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "pz6-21"
    }
  }, [_c('em', [_vm._v("Life’s Little Instruction Book™ from Mothers to Daughters")]), _vm._v(" "), _c('br'), _vm._v(" (with Kim Shea)")]), _vm._v(" "), _c('p', {
    staticClass: "noind1",
    attrs: {
      "id": "ARm"
    }
  }, [_c('em', [_vm._v("Life’s Little Instruction Book™ for Incurable Romantics")]), _vm._v(" "), _c('br'), _vm._v(" (with Robyn Spizman)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bab2f1ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 72
// module chunks = 0